module.exports = __webpack_public_path__ + "img/hp-bluepage.ef94e9c6.svg";